import React from "react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumbs = ({ cms }) => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Extract the dynamic segment (first part of the URL)
  const dynamicPrefix = pathnames[0] || "";

  const breadcrumbLinks = [
    { name: cms?.label_bcrumb_home, path: `/${dynamicPrefix}` },
    {
      name: cms?.label_bcrumb_makepayment,
      path: `/${dynamicPrefix}/makepayment`,
    },
    { name: cms?.label_bcrumb_confirm, path: `/${dynamicPrefix}/confirm` },
    { name: cms?.label_brumb_contactus, path: `/${dynamicPrefix}/contact_us` },
    {
      name: cms?.label_bcrumb_glossary_accr,
      path: `/${dynamicPrefix}/glossary`,
    },
    {
      name: cms?.label_bcrumb_faq_accr,
      path: `/${dynamicPrefix}/faq`,
    },
    {
      name: cms?.label_bcrumb_langproficiency,
      path: `/${dynamicPrefix}/language_proficiency`,
    },
  ];

  return (
    <nav aria-label="breadcrumb" className="breadcrumb-mobile-gap">
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link
            to={`/${dynamicPrefix}`}
            className="text-decoration-none fw-semibold"
          >
            <i className={`fe fe-home me-2 ${dynamicPrefix?.toLowerCase() === 'bcbsaz' ? 'navy-icon' : ''}`}></i>
            {cms?.label_bcrumb_home}
          </Link>
        </li>
        {pathnames.slice(1).map((value, index) => {
          const to = `/${pathnames.slice(0, index + 2).join("/")}`;
          const current = breadcrumbLinks.find((link) => link.path === to);
          return (
            <li key={to} className="breadcrumb-item">
              {current ? (
                <Link to={to} className="text-decoration-none">
                  {current.name}
                </Link>
              ) : (
                <span>{value}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
